import {
  VEHICLE_HISTORY_KEY,
  readVehicleHistory,
  writeVehicleHistory,
} from './vehicleHistoryStorage'

export const MAX_COOKIE_HEADER_BYTES = 4096

const PRUNABLE_MIN_BYTES = 256

const ESSENTIAL_COOKIE_PREFIXES = [
  'agmauth.',
  'adminagmauth.',
  'CookieConsent',
  'i18n_redirected',
  'order_token',
  'favorite_token',
  'selected_vehicle',
  'user_country',
  'search_history',
  'dismiss_message',
  'hide_home_infos',
  'admin_logged_in_user',
  'analytics',
  'cf_clearance',
  '_ga',
  '_gcl',
  '_fbc',
  '_fbp',
]

const isEssential = name =>
  ESSENTIAL_COOKIE_PREFIXES.some(prefix => name.startsWith(prefix))

const parseCookies = () =>
  document.cookie
    .split('; ')
    .filter(Boolean)
    .map(entry => ({
      name: entry.split('=')[0],
      size: entry.length,
    }))

export const cookieHeaderSize = () =>
  typeof document === 'undefined' ? 0 : document.cookie.length

export const removeCookieEverywhere = name => {
  const expiry = 'expires=Thu, 01 Jan 1970 00:00:00 GMT'
  const hostParts = window.location.hostname.split('.')
  const domains = ['']
  for (let i = 0; i < hostParts.length - 1; i++) {
    domains.push(hostParts.slice(i).join('.'))
  }
  domains.forEach(domain => {
    const domainPart = domain ? `; domain=${domain}` : ''
    document.cookie = `${name}=; path=/; ${expiry}${domainPart}`
    document.cookie = `${name}=; ${expiry}${domainPart}`
  })
}

const parseLegacyHistoryCookie = rawValue => {
  try {
    const parsed = JSON.parse(decodeURIComponent(rawValue))
    return Array.isArray(parsed) ? parsed : null
  } catch {
    return null
  }
}

export const migrateVehicleHistoryCookie = () => {
  if (typeof document === 'undefined') return
  const prefix = `${VEHICLE_HISTORY_KEY}=`
  const entry = document.cookie.split('; ').find(c => c.startsWith(prefix))
  if (!entry) return
  const parsed = parseLegacyHistoryCookie(entry.slice(prefix.length))
  if (parsed && parsed.length > 0) {
    if (!readVehicleHistory()) {
      writeVehicleHistory(parsed)
    }
    if (!readVehicleHistory()) return
  }
  removeCookieEverywhere(VEHICLE_HISTORY_KEY)
}

export const pruneOversizedCookies = ({
  maxBytes = MAX_COOKIE_HEADER_BYTES,
  purgeAll = false,
} = {}) => {
  if (typeof document === 'undefined') return 0

  const before = cookieHeaderSize()

  migrateVehicleHistoryCookie()

  if (!purgeAll && cookieHeaderSize() <= maxBytes) {
    return before - cookieHeaderSize()
  }

  const candidates = parseCookies()
    .filter(c => !isEssential(c.name) && c.size >= PRUNABLE_MIN_BYTES)
    .sort((a, b) => b.size - a.size)

  for (const cookie of candidates) {
    if (!purgeAll && cookieHeaderSize() <= maxBytes) break
    removeCookieEverywhere(cookie.name)
  }

  return before - cookieHeaderSize()
}
